import { JSX, PropsWithChildren } from 'react';
import { Text as JssText, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { C49ClickablePhotoContentCardProps } from './C49ClickablePhotoContentCard.types';
import { ClickablePhotoContentCard, Container } from '@ahc-digital/component-library';
import { translationClasses } from '@/shared/TranslationClasses';
import { getCheckbox } from '@/shared/param-utils';
import { CreateC49ClickablePhotoContentCardModel } from './C49ClickablePhotoContentCard.service';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

export const Default = (props: C49ClickablePhotoContentCardProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing ?? false;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const model = CreateC49ClickablePhotoContentCardModel({ props, isEditing });

  if (isEditing) {
    const Field = ({ children }: PropsWithChildren) => (
      <div style={{ display: 'grid', gap: '0.5rem' }}>{children}</div>
    );

    return (
      <Container>
        <div style={{ display: 'grid', gap: '1.5rem', marginBottom: '1.5rem' }}>
          <Field>
            <b>Image:</b>
            {model.image}
          </Field>
          <Field>
            <b>Headline:</b>
            {model.headline}
          </Field>
          <Field>
            <b>Support copy:</b>
            {model.supportCopy}
          </Field>
          <Field>
            <b>CTA:</b>
            {model.cta}
          </Field>
          <Field>
            <b>Link title:</b>
            <JssText field={props?.fields?.LinkTitle} />
          </Field>
        </div>
      </Container>
    );
  }

  return (
    <ClickablePhotoContentCard
      verticalSpacing
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      shouldLazyLoad={getCheckbox(props?.params?.ShouldLazyLoad)}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C49ClickablePhotoContentCardProps>(Default);
